<template>
  <div class="hospital">
    <div class="container">
      <div class="titleNav">
        <router-link to="/courier/cityExpress">我要下单</router-link> <span>/</span>
        <router-link to="/courier/medical">医疗服务</router-link> <span>/</span>
        <a href="javascript:;">医院详情</a> <span v-if="$route.name == 'Doctor'">/</span>
        <a href="javascript:;" v-if="$route.name == 'Doctor'">医生列表</a> <span v-if="$route.name == 'DoctorDetail'">/</span>
        <a href="javascript:;" v-if="$route.name == 'DoctorDetail'">医生详情</a>
      </div>
      <div class="content">
        <!--<left-nav></left-nav>-->
        <div class="leftNav">
          <div class="nav">
            <ul class="firstList">
              <li class="firstItem" v-for="(item, index) in hospitalLeft" :key="item.id" @click="hanlderClick(index)">
                <p class="boxItem" :class="i === index ? 'bg' : ''">
                  <span>{{item.name}}</span>
                  <i class="iconfont " :class="i === index ? 'icon-xiajiantou2' : 'icon-youjiantou7'"></i>
                </p>
                <ul class="secondList" v-if="i === index" style="height: auto;transition: 10s">
                  <li class="secondItem" @click="toDoctor(item.id, childItem.id,item.name, childItem.name)" v-for="(childItem, index) in item.departmentBs" :key="childItem.id">{{childItem.name}}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {reqHospitalInfo} from '../../../api'
export default {
  data () {
    return {
      i: '',
      hospitalLeft: []
    }
  },
  created() {
    const {hospitalId} = this.$route.query
    reqHospitalInfo(hospitalId).then(res => {
      if(res.code === 200){
        this.hospitalLeft = res.data.bussData.departmentAs
      }
    })
  },
  methods: {
    hanlderClick (i) {
      this.i = i
    },
    toDoctor (departmentIdA, departmentIdB, departmentIdAName,departmentIdBName) {
      const {hospitalId} = this.$route.query
      this.$router.push({name: 'Doctor', query: {hospitalId, departmentIdA, departmentIdB,departmentIdAName,departmentIdBName}})
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.hospital{
  .titleNav{
    margin:30px 0;
  }
  .content{
    overflow: hidden;
  }
}
.leftNav{
  .nav{
    float: left;
    width: 140px;
    margin-right: 40px;
    /*padding:0 22px 0 18px;*/
    border-radius:20px 20px 0px 0px;
    border:1px solid #e1e1e1;
    box-sizing: border-box;
    .firstItem{
      position: relative;
      line-height: 48px;
      text-indent: 20px;
      cursor: pointer;
      &:last-of-type{
        border: none;
      }
      &:first-of-type{
        .boxItem{
          border-radius:20px 20px 0px 0px;
        }
      }
      .boxItem{
        &:after{
          display: block;
          content:'';
          width: 100px;
          height: 1px;
          margin-left: 18px;
          background: #e1e1e1;
        }
        span{
          display: block;
          width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

        }
        i{
          position: absolute;
          top: 0;
          right: 22px;
        }
        &.bg{
          background: #2fa1de;
          color:#fff;
          border:none;
          &:after{
            display: none;
          }
        }
      }

      .secondList{
        background: #fafafa;
        overflow: hidden;
        height: 0;
        transition: 10s;
        .secondItem{
          float: left;
          text-indent: 20px;
          cursor: pointer;
          &:after{
            display: block;
            content:'';
            width: 100px;
            height: 1px;
            margin-left: 18px;
            background: #f1f1f1;
          }
          &:last-of-type{
            border: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Hospital/Hospital.vue